import { render } from "./countdown.vue?vue&type=template&id=f74bd5ca"
import script from "./countdown.vue?vue&type=script&lang=js"
export * from "./countdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__